import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import FavoriteIcon from "@material-ui/icons/Favorite";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles((theme) => ({
    iconButton: {
        width: 30,
        height: 30,
        padding: 0,
        left: -10,
        display: 'inline-block',
        [theme.breakpoints.between('400', '450')]: {
            left: -10,
        },
        [theme.breakpoints.between('450', '500')]: {
            left: -20,
        },
        [theme.breakpoints.between('500', '550')]: {
            left: -35,
        },
        [theme.breakpoints.between('550', '600')]: {
            left: -40,
        },
    },
    icon: {
        display: 'inline-block',
        color: 'rgb(37, 37, 37)',
        fill: theme.palette.pink,
        userSelect: 'none',
        transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
        '&:hover': {
            color: theme.palette.iconHover,
            fill: theme.palette.iconHover,
        },
    },
    spanText: {
        fontFamily: 'Arial',
        paddingLeft: 2,
        fontSize: 12,
        verticalAlign: 'bottom',
        display: 'inline',
        color: 'rgb(176, 176, 176)'
    }
}));

const HeartButton = (props) => {
    const classes = useStyles();

    const heart = props.heart || 0;
    function onClickHandler(event) {
        props.onFavouriteClickHandler(event);
    }
    const title = props.isHearted ? `Un-heart ${props.name||''}` : `Heart ${props.name||''}`;

    return(
        <Tooltip title={title}>
        <IconButton className={classes.iconButton} onClick={onClickHandler}>
            {props.isHearted ? (
                <FavoriteIcon className={classes.icon} style={props.style} />
            ) : (
                <FavoriteBorderIcon className={classes.icon} style={props.style} />
            )}
            {/*<span className={classes.spanText}>{heart}</span>*/}
        </IconButton>
        </Tooltip>
    );
};

export default HeartButton;